import { render } from "./VehicleDescriptionPagePC.vue?vue&type=template&id=51e13b8c&scoped=true"
import script from "./VehicleDescriptionPagePC.vue?vue&type=script&lang=js"
export * from "./VehicleDescriptionPagePC.vue?vue&type=script&lang=js"

import "./VehicleDescriptionPagePC.vue?vue&type=style&index=0&id=51e13b8c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-51e13b8c"

export default script